import { defineComponent as r, computed as o, openBlock as a, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "4492dad5-7da5-450b-b5cc-5a44e812aaf1" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#4492dad5-7da5-450b-b5cc-5a44e812aaf1)" }, p = { key: 0 }, v = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m0 322.8 253.6-18.4L512 322.8v33.4l-258 15.3L0 356.2zm0 66.8 257.2-13.8L512 389.6V423l-253 16.9L0 423z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#338af3",
  d: "M0 0h512v322.8H0zm0 356.2h512v33.4H0zM0 423h512v89H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m117.3 161.5-50-22.1 50-22 22-50.1 22.2 50 50 22-50 22.2-22.1 50z"
}, null, -1), z = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "m139.4 94.9 13.6 30.9 31 13.6-31 13.6-13.6 31-13.6-31-31-13.6 31-13.6z"
}, null, -1), w = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ r({
  __name: "aw",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (a(), i("title", p, d(t.flagName), 1)) : _("", !0),
        v,
        k,
        g,
        z
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=aw-c84b7c6c.js.map
